module.exports = __webpack_public_path__ + "static/media/VectorLocation.98982c64.svg";